import React, { useEffect, useState } from "react";
import { FiClock, FiInfo } from "react-icons/fi";
import { Map, Marker, TileLayer } from "react-leaflet";

import mapIcon from '../utils/mapIcon';

import '../styles/pages/orphanage.css';
import Sidebar from "../components/Sidebar";
import api from "../services/api";
import { useParams } from "react-router-dom";

interface Orphanage {
  name: string,
  latitude: number,
  longitude: number,
  about: string,
  instructions: string,
  opening_hours: string,
  open_on_weekends: boolean,
  images: Array<{
    id: number,
    url: string,
  }>,
}

interface OrphanageParams {
  id: string,
}

export default function Orphanage() {
  const [orphanage, setOrphanage] = useState<Orphanage>();
  const [activeImgIdx, setActiveImgIdx] = useState(0);
  const params = useParams<OrphanageParams>();

  useEffect(() => {
    api.get(`orphanages/${params.id}`).then(response => {
      setOrphanage(response.data);
    })
  }, [params.id]);

  if(!orphanage) return <p>Carregando...</p>

  return (
    <div id="page-orphanage">
      <Sidebar />

      <main>
        <div className="orphanage-details">
          <img src={orphanage.images[activeImgIdx].url} alt={orphanage.name} />

          <div className="images">
            {orphanage.images.map((image, idx) => (
              <button
                key={image.id}
                className={activeImgIdx === idx ? 'active' : ''}
                type="button"
                onClick= {() => {
                  setActiveImgIdx(idx)
                }}
              >
                <img
                  key={image.id}
                  src={image.url}
                  alt={orphanage.name}
                />
              </button>
            ))}
          </div>
          
          <div className="orphanage-details-content">
            <h1>{orphanage.name}</h1>
            <p>{orphanage.about}</p>

            <div className="map-container">
              <Map 
                center={[orphanage.latitude, orphanage.longitude]} 
                zoom={16} 
                style={{ width: '100%', height: 280 }}
                dragging={false}
                touchZoom={false}
                zoomControl={false}
                scrollWheelZoom={false}
                doubleClickZoom={false}
              >
                <TileLayer 
                  url={`https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png`}
                />
                <Marker interactive={false} icon={mapIcon} position={[orphanage.latitude, orphanage.longitude]} />
              </Map>

              <footer>
                <a target='_blank' rel='noopener noreferrer' href={`https://www.google.com/maps/dir/?api=1&destination=${orphanage.latitude},${orphanage.longitude}`}>Ver rotas no Google Maps</a>
              </footer>
            </div>

            <hr />

            <h2>Instruções para visita</h2>
            <p>{orphanage.instructions}</p>

            <div className="open-details">
              <div className="hour">
                <FiClock size={32} color="#15B6D6" />
                {orphanage.opening_hours}
              </div>
              { orphanage.open_on_weekends ? (
                <div className="open-on-weekends">
                  <FiInfo size={32} color="#39CC83" />
                  Atendemos <br />
                  fim de semana
                </div>
              ) : (
                <div className="open-on-weekends dont-open">
                  <FiInfo size={32} color="#ff669d" />
                  Não Atendemos <br />
                  fim de semana
                </div>
              )}
            </div>

            {/*<button type="button" className="contact-button">
              <FaWhatsapp size={20} color="#FFF" />
              Entrar em contato
              </button>*/}
          </div>
        </div>
      </main>
    </div>
  );
}